import React from 'react';
import {
    CircularProgress,
    makeStyles
} from '@material-ui/core';

const useStyles = makeStyles({
    loading: {
        display: 'flex',
        justifyContent: 'center'
        //minHeight: '-webkit-fill-available'
    }
});

function Loading() {
    const classes = useStyles();

    return (
        <div className={classes.loading}>
            <CircularProgress color='secondary' />
        </div>
    );
}

export default Loading;